import { useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../../../../parts/modal-new";
import SvgIcon from "../../../../parts/SvgIcon";

const ProgramFilterModal = ({
  programOptions,
  selectedPrograms,
  setSelectedPrograms,
}) => {
  const { t } = useTranslation("coaching-portal");
  const [showModal, setShowModal] = useState(false);
  const [staged, setStaged] = useState(new Set(selectedPrograms));

  const handleOpen = () => {
    setStaged(new Set(selectedPrograms));
    setShowModal(true);
  };

  const toggleStaged = (prog) => {
    setStaged((prev) => {
      const next = new Set(prev);
      if (next.has(prog)) next.delete(prog);
      else next.add(prog);
      return next;
    });
  };

  const handleApply = () => {
    setSelectedPrograms(staged);
    setShowModal(false);
  };

  return (
    <>
      <button
        data-button-type="secondary"
        data-icon
        onClick={handleOpen}
        type="button"
      >
        <SvgIcon src="/img/new-icons/filter-white.svg" />
        {selectedPrograms.size > 0
          ? t("challengeReport.filter.programTeamCount", {
              count: selectedPrograms.size,
            })
          : t("challengeReport.filter.programTeam")}
      </button>
      {showModal && (
        <Modal
          title={t("challengeReport.filter.modalTitle")}
          onClose={(e) => {
            e.preventDefault();
            setShowModal(false);
          }}
          className="program-filter"
        >
          <div className="body">
            <ul className="flex flex-wrap gap-4 max-w-lg">
              {programOptions.map((prog) => (
                <li key={prog}>
                  <label className="flex! items-center gap-1 opacity-100! mb-0!">
                    <input
                      type="checkbox"
                      checked={staged.has(prog)}
                      onChange={() => toggleStaged(prog)}
                    />
                    {prog}
                  </label>
                </li>
              ))}
            </ul>
          </div>
          <footer>
            {staged.size > 0 && (
              <button
                type="button"
                data-button-type="secondary"
                onClick={() => setStaged(new Set())}
                data-action="cancel"
              >
                {t("challengeReport.filter.clearAll")}
              </button>
            )}
            <button
              type="button"
              data-button-type="primary"
              onClick={handleApply}
            >
              {t("challengeReport.apply")}
            </button>
          </footer>
        </Modal>
      )}
    </>
  );
};

export default ProgramFilterModal;
